var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMintS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H5.55556V6.44444H2V2ZM2.88889 2.88889V5.55556H4.66667V2.88889H2.88889ZM6.44444 2H10V4.66667H6.44444V2ZM7.33333 2.88889V3.77778H9.11111V2.88889H7.33333ZM6.44444 5.55556H10V10H6.44444V5.55556ZM7.33333 6.44444V9.11111H9.11111V6.44444H7.33333ZM2 7.33333H5.55556V10H2V7.33333ZM2.88889 8.22222V9.11111H4.66667V8.22222H2.88889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintS);
export default __webpack_public_path__ + "static/media/mint-s.0b820f114ea629982c95e0cec22ccb0c.svg";
export { ForwardRef as ReactComponent };